import { createSlice } from "@reduxjs/toolkit";
import { notification } from "antd";
import i18next from "i18next";

const userSubscriptionSlice = createSlice({
  name: "userSubscription",
  initialState: {
    loading: false,
    error: false,
    loadingPayment: false,
    loadingCancel: false,
    checkout_url: null,
    userSubscriptionList: [],
    userSubscription: {},
    isCancelSuccess: false,
    isPaymentComplete: false,
    userSubscriptionHistory: [],
    portalUrl: null,
    pagination: {
      total: 0,
      current: 1,
      size: 10
    }
  },
  reducers: {
    subscriptionPlanRequest: (state) => {
      state.loading = true;
    },
    subscriptionPlanSuccess: (state, action) => {
      state.loading = false;
      state.userSubscriptionList = action.payload;
    },
    subscriptionPlanFailure: (state) => {
      state.loading = false;
    },

    userSubscriptionPaymentRequest: (state) => {
      state.loadingPayment = true;
      state.checkout_url = null;
      state.error = null;
      state.isPaymentComplete = false;
    },
    userSubscriptionPaymentSuccess: (state, action) => {
      state.loadingPayment = false;
      state.checkout_url = action.payload.checkoutUrl;
      state.isPaymentComplete = true;
    },
    userSubscriptionPaymentFailure: (state, action) => {
      state.loadingPayment = false;
      state.error = action.payload.response.data.message;
      state.isPaymentComplete = false;
      notification.error({
        message: i18next.t("subscription.subscriptionFailedTitle"),
        description: state.error,
        placement: "topRight"
      });
    },

    getUserSubscriptionRequest: (state) => {
      state.loading = true;
      state.userSubscription = null;
      state.error = null;
    },
    getUserSubscriptionSuccess: (state, action) => {
      state.loading = false;
      state.userSubscription = action.payload;
    },
    getUserSubscriptionFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload.response?.data?.message;
    },

    cancelUserSubscriptionRequest: (state) => {
      state.loadingCancel = true;
      state.isCancelSuccess = false;
      state.error = null;
    },
    cancelUserSubscriptionSuccess: (state) => {
      state.loadingCancel = false;
      state.isCancelSuccess = true;
      notification.success({
        message: i18next.t("subscription.cancelSuccessTitle"),
        description: i18next.t("subscription.cancelSuccessMessage"),
        placement: "topRight"
      });
    },
    cancelUserSubscriptionFailure: (state, action) => {
      state.loadingCancel = false;
      state.isCancelSuccess = false;
      state.error = action.payload.response?.data?.message;
      notification.error({
        message: i18next.t("subscription.cancelFailedTitle"),
        description: state.error,
        placement: "topRight"
      });
    },

    getUserSubscriptionHistoryRequest: (state) => {
      state.loading = true;
      state.userSubscriptionHistory = [];
      state.error = null;
    },
    getUserSubscriptionHistorySuccess: (state, action) => {
      state.loading = false;
      state.userSubscriptionHistory =
        action.payload.userSubscriptionHistoryDtos || [];

      state.pagination = {
        total: action.payload.totalCount ?? 0,
        current: action.payload.page ?? 0,
        size: action.payload.size ?? 10
      };
    },
    getUserSubscriptionHistoryFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload.response?.data?.message;
    },

    createCustomerPortalSessionRequest: (state) => {
      state.loadingPayment = true;
      state.portalUrl = null;
      state.error = null;
    },
    createCustomerPortalSessionSuccess: (state, action) => {
      state.loadingPayment = false;
      state.portalUrl = action.payload.customerPortal;
    },
    createCustomerPortalSessionFailure: (state, action) => {
      state.loadingPayment = false;
      state.error = action.payload?.response?.data?.message || null;
      notification.error({
        message: i18next.t("subscription.portalOpenFailed"),
        description: action.payload?.response?.data?.message,
        placement: "topRight"
      });
    },
    reset: (state) => {
      state.error = null;
      state.isCancelSuccess = false;
      state.isPaymentComplete = false;
    }
  }
});

export const {
  subscriptionPlanRequest,
  subscriptionPlanSuccess,
  subscriptionPlanFailure,
  userSubscriptionPaymentRequest,
  userSubscriptionPaymentSuccess,
  userSubscriptionPaymentFailure,
  getUserSubscriptionRequest,
  getUserSubscriptionSuccess,
  getUserSubscriptionFailure,
  cancelUserSubscriptionRequest,
  cancelUserSubscriptionSuccess,
  cancelUserSubscriptionFailure,
  getUserSubscriptionHistoryRequest,
  getUserSubscriptionHistorySuccess,
  getUserSubscriptionHistoryFailure,
  createCustomerPortalSessionRequest,
  createCustomerPortalSessionSuccess,
  createCustomerPortalSessionFailure,
  reset
} = userSubscriptionSlice.actions;
export default userSubscriptionSlice.reducer;
